'use strict';

export default class MainCtrl {
  static get UID() {
    return 'mainCtrl';
  }

  constructor( $rootScope, $cookies, $state, siteConst, BASE_URLS ) {
    'ngInject';
    Object.assign(this, { $rootScope, $cookies, $state, siteConst, BASE_URLS } );

    this.currentDate = Date.now();

    $rootScope.$state = this.$state;
    $rootScope.pager = this.pager;
    $rootScope.BASE_CONTENT = BASE_URLS && BASE_URLS.CONTENT ? BASE_URLS.CONTENT : '';

		if( this.$cookies.get('sonWarning') === 1 && this.$state.current.name === 'warning') {
			console.log('Redir tour');
			this.$state.go('tour');
		}

  }
		
  enterClick() {
    this.$cookies.put('sonWarning', 1);
    this.$state.go('tour');
  }

  pager(pageNumber) {
    let pn = parseInt(pageNumber, 10) || 1;
    this.$state.go('.', {pageNum: pn}, {location: true});
  }

}



// WEBPACK FOOTER //
// ./~/site_core/src/features/main/mainCtrl.js